import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 150px;
`;

export const MinMax = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #d6f1f5;
  padding: 15px 20px;
  gap: 4px;
  border-radius: 4px;
  justify-content: center;

  span {
    display: flex;
    gap: 3px;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
  }

  /* Sem isto, um texto longo espremia a seta a 0px. */
  svg {
    flex-shrink: 0;
  }
`;

/** O rótulo acima de um valor: o componente da pressão, ou "Pior noite", "Dia mais ativo". */
export const Component = styled.p`
  font-size: 0.75rem;
  font-weight: 700;
  color: #1c71a1;
  text-transform: uppercase;

  & + span {
    margin-top: 2px;
  }

  span + & {
    margin-top: 8px;
  }
`;

/** O dia do extremo, ao lado do valor ("(28/09)"). */
export const When = styled.small`
  font-size: 0.75rem;
  color: #4f4f4f;
  margin-left: 2px;
`;

export const Note = styled.p`
  font-size: 0.75rem;
  line-height: 1.3;
  color: #4f4f4f;
`;

export const LastMeasurement = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  border-radius: 6px;
  border: 1px solid #bdbdbd;
  text-align: center;

  padding: 0;

  strong {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    padding: 8px 0;

    background-color: #2d9cdb;
  }
`;

export const LastRegister = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0px 8px;
  padding-bottom: 16px;
  gap: 4px;
  flex-direction: column;
  min-height: 75px;

  h3 {
    font-size: 2.25rem;
    color: #1c71a1;
    font-weight: 600;
  }

  span:nth-of-type(2) {
    font-size: 0.625rem;
    text-transform: uppercase;
  }

  div span {
    font-size: 0.625rem;
    position: absolute;
    bottom: 8px;
    right: 22px;
    font-weight: 700;
    color: #1c71a1;
  }
`;
